'use client'

import { H3 } from '@/components/common/Typo'
import IconFacebook from '@/components/icons/IconFacebook'
import IconInstagram from '@/components/icons/IconInstagram'
import IconTwitter from '@/components/icons/IconTwitter'
import IconYoutube from '@/components/icons/IconYoutube'
import { useTranslate } from '@tolgee/react'

interface SocialMediaProps {
  settings: {
    headingsText: string
    facebookUrl: string
    instagramUrl: string
    twitterUrl: string
    youtubeUrl: string
  }
}

const SocialMedia = ({ settings }: SocialMediaProps): JSX.Element => {
  const { t } = useTranslate()

  const parseHref = (url: string) => {
    if (!url) return '#'
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url
    }
    return `https://${url}`
  }

  return (
    <div>
      <H3 className="normalised text-center font-bold md:text-left">
        {settings.headingsText}
      </H3>
      <div className="mt-2 text-center md:text-left">
        {settings.facebookUrl && (
          <a
            target="_blank"
            href={parseHref(settings.facebookUrl)}
            className="mr-6 inline-block hover:opacity-80"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <IconFacebook className="text-body" />
          </a>
        )}
        {settings.instagramUrl && (
          <a
            target="_blank"
            href={parseHref(settings.instagramUrl)}
            className="mr-6 inline-block hover:opacity-80"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <IconInstagram className="text-body" />
          </a>
        )}
        {settings.twitterUrl && (
          <a
            target="_blank"
            href={parseHref(settings.twitterUrl)}
            className="mr-6 inline-block hover:opacity-80"
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            <IconTwitter className="text-body" />
          </a>
        )}
        {settings.youtubeUrl && (
          <a
            target="_blank"
            href={parseHref(settings.youtubeUrl)}
            className="mr-6 inline-block hover:opacity-80"
            rel="noopener noreferrer"
            aria-label="Youtube"
          >
            <IconYoutube className="text-body" />
          </a>
        )}
      </div>
    </div>
  )
}

export default SocialMedia
